import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import strings from 'utils/strings'

import { schemaProp } from 'schemas/validation'
import conditionSchema from 'schemas/validation/feature/conditionSchema'

import { CHEC_MAX_VALUE } from 'utils/constants'
import { OPERATORS_REQUIRING_HYSTERESIS } from 'constants/conditions'

import { StyledNumberInput } from './HysteresisEditor.style'

const rule = schemaProp(conditionSchema)

const HysteresisEditor = ({
  className,
  hysteresis,
  onHysteresisChange,
  operator,
  minValue,
  maxValue,
  units,
}) => {
  const numOperator = parseInt(operator, 10)

  return (
    OPERATORS_REQUIRING_HYSTERESIS.has(numOperator) && (
      <div className={classNames(className, 'hysteresis-editor')}>
        <StyledNumberInput
          name={strings.hysteresis}
          label={strings.hysteresis_units(units)}
          vertical
          value={hysteresis}
          onChange={onHysteresisChange}
          className="form-field"
          rules={rule('hysteresis', { minValue, maxValue })}
          data-testid="hysteresis-editor-input"
        />
      </div>
    )
  )
}

HysteresisEditor.defaultProps = {
  minValue: 0,
  maxValue: CHEC_MAX_VALUE,
}

HysteresisEditor.propTypes = {
  className: PropTypes.string,
  hysteresis: PropTypes.number,
  onHysteresisChange: PropTypes.func,
  operator: PropTypes.number,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  units: PropTypes.string,
}

export default HysteresisEditor
